
























import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import { renderRichText } from '@storyblok/nuxt-2';

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<any>,
      default: {},
    },
  },
  setup() {
    const modalActive = ref(false);

    const showModal = () => {
      modalActive.value = true;
    };
    const closeModal = () => {
      modalActive.value = false;
    };

    return {
      modalActive,
      showModal,
      closeModal,
      renderRichText,
    };
  },
});
